import { useRef, useState } from "react";
import { ChevronRight } from "lucide-react";
import { useAuth } from "../lib/auth";
import BrandMark from "../components/BrandMark";

export default function Login() {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const submittingRef = useRef(false);

  const submit = async (e) => {
    e.preventDefault();
    if (submittingRef.current) return;
    submittingRef.current = true;
    setError("");
    setBusy(true);
    try {
      await login(email, password);
    } catch (err) {
      setError(err.response?.data?.detail || "Gagal masuk");
    } finally {
      submittingRef.current = false;
      setBusy(false);
    }
  };

  return (
    <main className="login-page" data-module="dashboard">
      <section className="login-card login-panel">
        <div className="login-mark" data-testid="login-brand">
          <BrandMark stacked />
        </div>
        <p className="eyebrow">SISTEM PRODUKSI</p>
        <h1>
          Jaga setiap <em>cetakan</em> tetap jalan.
        </h1>
        <p className="login-copy">Satu alur jelas dari Order Masuk sampai Terkirim.</p>
        <form onSubmit={submit} data-testid="login-form">
          <label>
            Email
            <input data-testid="login-email-input" value={email} onChange={(e) => setEmail(e.target.value)} type="email" required />
          </label>
          <label>
            Kata Sandi
            <input data-testid="login-password-input" value={password} onChange={(e) => setPassword(e.target.value)} type="password" required />
          </label>
          {error && <div className="error" data-testid="login-error">{error}</div>}
          <button type="submit" className="primary full" data-testid="login-submit-button" disabled={busy}>
            {busy ? "Memproses..." : "Masuk ke workspace"} <ChevronRight size={18} />
          </button>
        </form>
        <p className="demo-note" data-testid="login-note">Gunakan akun operasional Anda. Hubungi Admin bila password terlupa.</p>
      </section>
    </main>
  );
}
